import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import _ from "lodash";

const ActionToast = ({ message, actions, customComponent }) => (
  <div>
    <div>{message}</div>

    {customComponent ||
      (!_.isEmpty(actions) && (
        <div className="d-flex mt-1" style={{ gap: 10 }}>
          {actions.map((action) => (
            <Button.Ripple
              key={action.title}
              color={action.buttonColor || "success"}
              className={action.className || ""}
              {...action.buttonProps}
              size="sm"
              outline={action.outline !== false}
              onClick={action.clickHandler}
            >
              {action.title}
            </Button.Ripple>
          ))}
        </div>
      ))}
  </div>
);

export default ActionToast;

ActionToast.propTypes = {
  message: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      buttonColor: PropTypes.string,
      title: PropTypes.string.isRequired,
      outline: PropTypes.bool,
      clickHandler: PropTypes.func,
      className: PropTypes.string,
      buttonProps: PropTypes.object,
    })
  ),
  customComponent: PropTypes.element,
};

ActionToast.defaultProps = {
  actions: [],
  customComponent: null,
};
